import { UnorderedSearchIndex } from 'js-search'

// from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator/Collator
const COMPARISON_OPTIONS = {
  // matches characters regardless of accent or case
  sensitivity: 'base',
  // takes into account numbers Shelf 03 < Shelf 3 < Shelf 10
  numeric: true
}

export class AscendingLabelIndex extends UnorderedSearchIndex {
  // Used by js-search
  // Sorts the index query results by a name property that's expected to be in each indexed document
  // For example, this works great for an indexed list of select options of type: { name: string, value: number }[]
  search(tokens: string[], corpus: any[]): any[] {
    const documents = super.search(tokens, corpus)
    return documents.sort((a, b) => a.label?.localeCompare(b.label, undefined, COMPARISON_OPTIONS) || 0)
  }
}
